(function () {
  function parseCssPx(value) {
    var n = parseFloat(value);
    return Number.isFinite(n) ? n : 0;
  }

  function stickyHeaderOffsetPx() {
    var styles = window.getComputedStyle(document.body);
    var announcement = parseCssPx(styles.getPropertyValue('--cclp-announcement-height'));
    var header = parseCssPx(styles.getPropertyValue('--cclp-header-height'));
    if (!header) {
      header = window.matchMedia('(min-width: 1024px)').matches ? 75 : 70;
    }
    return announcement + header;
  }

  class CclpStickyCta extends HTMLElement {
    constructor() {
      super();
      this._onScroll = this._onScroll.bind(this);
      this._onResize = this._onResize.bind(this);
      this._onBarClick = this._onBarClick.bind(this);
      this._onSectionLoad = this._onSectionLoad.bind(this);
    }

    connectedCallback() {
      this.bar = this.querySelector('.cclp-sticky-cta');
      if (!this.bar) return;

      this.threshold = parseInt(this.dataset.scrollThreshold || '300', 10);
      if (!Number.isFinite(this.threshold)) this.threshold = 300;

      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize);
      document.addEventListener('shopify:section:load', this._onSectionLoad);

      this.bar.addEventListener('click', this._onBarClick);

      this._syncVisibility();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
      document.removeEventListener('shopify:section:load', this._onSectionLoad);

      if (this.bar) {
        this.bar.removeEventListener('click', this._onBarClick);
      }

      document.body.style.setProperty('--cclp-sticky-cta-pad', '0px');
    }

    _onBarClick(ev) {
      var smooth = ev.target.closest('a.js-smoothScroll');
      if (smooth && this.bar.contains(smooth)) {
        this._onSmoothClick(ev, smooth);
        return;
      }
      var atc = ev.target.closest('.cclp-sticky-cta__button--atc');
      if (atc && this.bar.contains(atc)) {
        this._onAtcClick(ev, atc);
      }
    }

    _onSectionLoad(event) {
      var target = event.target;
      if (target && typeof target.contains === 'function' && target.contains(this)) {
        this._syncVisibility();
      }
    }

    _syncVisibility() {
      if (!this.bar) return;
      var visible = window.scrollY >= this.threshold;
      this.bar.classList.toggle('is-visible', visible);
      this._updateBodyPad();
    }

    _updateBodyPad() {
      if (!this.bar || !this.bar.classList.contains('is-visible')) {
        document.body.style.setProperty('--cclp-sticky-cta-pad', '0px');
        return;
      }
      var h = this.bar.offsetHeight;
      document.body.style.setProperty('--cclp-sticky-cta-pad', h + 'px');
    }

    _onScroll() {
      this._syncVisibility();
    }

    _onResize() {
      this._updateBodyPad();
    }

    _onSmoothClick(ev, elLink) {
      ev.preventDefault();
      elLink = elLink || ev.currentTarget;
      var href = elLink.getAttribute('href');
      if (!href || href.indexOf('#') === -1) return;

      var parts = href.split('#');
      var sectionId = parts.length > 1 ? parts[parts.length - 1] : '';
      if (!sectionId) return;

      var elSection = window.CclpScrollTarget ? window.CclpScrollTarget.find(sectionId) : null;
      if (!elSection) return;

      document.dispatchEvent(new CustomEvent('landing-header:close', { bubbles: true }));

      var rect = elSection.getBoundingClientRect();
      var targetY = rect.top;
      var currentY = window.scrollY;
      var offset = stickyHeaderOffsetPx();
      window.scroll({
        top: currentY + targetY - offset,
        left: 0,
        behavior: 'smooth',
      });
    }

    _onAtcClick(ev, btn) {
      btn = btn || ev.currentTarget;
      var id = parseInt(btn.getAttribute('data-variant-id') || '', 10);
      if (!id) return;

      var orig = btn.textContent;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function () {
          if (typeof window.refreshCart === 'function') {
            window.refreshCart();
          } else {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
        })
        .catch(function () {})
        .finally(function () {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          if (orig) btn.textContent = orig;
        });
    }
  }

  if (!customElements.get('cclp-sticky-cta')) {
    customElements.define('cclp-sticky-cta', CclpStickyCta);
  }
})();
